let HANDLER;
let FACTORY;
export const init = (handler, factory) => {
    HANDLER = handler;
    FACTORY = factory;
};
export const get = () => {
    if (!HANDLER) {
        throw new Error('WidgetsHandler is not initialized');
    }
    return HANDLER;
};
export const getFactory = () => {
    if (!FACTORY) {
        throw new Error('WidgetFactory is not initialized');
    }
    return FACTORY;
};
